<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6">
        <b-row>
          <b-col>
            <FormulateForm
              name="updateUser"
              @submit="submitHandler"
              #default="{ isLoading }"
              v-model="formValues"
            >
                  <iq-card>
                    <template v-slot:headerTitle>
                      <h4 class="card-title">User info</h4>
                    </template>
                    <template v-slot:body>
                      <b-form-row>
                        <b-col>
                          <b-form-group label="First name" label-for="firstName">
                            <FormulateInput
                              id="firstName"
                              name="firstName"
                              type="text"
                              input-class="form-control"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="Last name" label-for="lastName">
                            <FormulateInput
                              id="lastName"
                              name="lastName"
                              type="text"
                              input-class="form-control"
                            />
                          </b-form-group>
                        </b-col>
                      </b-form-row>
                      <b-form>
                        <b-form-group label="Email " label-for="email">
                          <FormulateInput
                            id="email"
                            name="email"
                            type="email"
                            validation="required"
                            input-class="form-control"
                          />
                        </b-form-group>
                      </b-form>
                      <b-form>
                        <b-form-group label="Avatar URL" label-for="avatarUrl">
                          <FormulateInput
                            id="avatarUrl"
                            name="avatarUrl"
                            type="text"
                            input-class="form-control"
                            validation="url_if_present"
                            validation-name="URL"
                            :validation-rules="{
                              url_if_present: ({ value }) => {
                                return !value || /^(https?:\/\/)?([^\s:@]+:[^\s:@]*@)?((?:[A-Za-z0-9\-]+\.)+[A-Za-z]{2,})((\/[^\s]*)?)$/.test(value)
                              }
                            }"
                            validation-messages="{
                              url_if_present: 'Please enter a valid image URL ending in .png, .jpg, or .svg or leave the field blank.'
                            }"
                          />
                        </b-form-group>
                      </b-form>
                      <b-form>
                        <b-form-group label="Avatar Color" label-for="avatarColor">
                          <FormulateInput
                              name="avatarColor"
                              type="select"
                              placeholder="Choose color"
                              :options="
                                colors.map(({value, label}) => ({
                                  value,
                                  label,
                                }))
                              "
                            />
                        </b-form-group>
                      </b-form>
                    </template>
                  </iq-card>
            </FormulateForm>
          </b-col>
        </b-row>
        <b-row>
            <b-col lg="6">
              <router-link to="/users">
                <b-button block variant="outline-primary" class="mb-3 mr-1"
                  >Back to users</b-button
                >
              </router-link>
            </b-col>
            <b-col lg="6">
              <b-button
                block
                type="submit"
                variant="primary"
                class="mb-3 mr-1"
                @click="submitHandler"
                :label="isLoading ? 'Loading...' : 'Submit this form'"
                >Save user</b-button
              >
            </b-col>
        </b-row>
      </b-col>
      
      <b-col lg="6">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Access to organizations</h4>
          </template>
          <template v-slot:body>
             <b-table
                hover
                responsive
                :items="userOrganizations"
                :fields="userOrganizationsFields"
                class="mb-0 table-borderless"
              >
                <template v-slot:cell(organization)="data">
                  {{ data.value }}
                  <b-badge
                      v-if="data.item.default"
                      pill
                      variant="primary"
                      class="ml-1"
                      >DEFAULT</b-badge>
                </template>
                <template v-slot:cell(action)="data">
                  <b-button
                    variant="outline-danger mr-2"
                    size="sm"
                    @click="toDeleteUserOrganization = data"
                  >
                    Remove
                  </b-button>
                </template>
              </b-table>
              <b-button block variant="success" outline size="lg" @click="toAddModalOpened=true">
                <i class="fas fa-plus"></i>
                Add to organization
              </b-button>
          </template>
          </iq-card>
      </b-col>
    </b-row>
    
    <b-modal
        id="delete-modal"
        :visible="!!toDeleteUserOrganization"
        title="Remove user from organization"
        @hidden="toDeleteUserOrganization = null"
      >
        <p v-if="toDeleteUserOrganization">
          User <strong>{{ toDeleteUserOrganization.item.prettyName }}</strong> will be removed from organization <strong>{{ toDeleteUserOrganization.item.organizationName }}</strong>.
        </p>
        <p>Are you sure?</p>
        <template #modal-footer="{}">
          <b-button
            size="sm"
            variant="outline-dark"
            @click="toDeleteUserOrganization = null"
            >Cancel</b-button
          >
          <b-button size="sm" variant="danger" @click="deleteItem(toDeleteUserOrganization.item.id)"
            >Remove</b-button
          >
        </template>
      </b-modal>

    <b-modal
        :visible="toAddModalOpened"
        title="Add user to organization"
        @hidden="toAddModalOpened=false"
        hide-footer
      >
        <FormulateForm
          name="addUserOrganization"
          v-model="addUserOrganizationFormValues"
                  >
                    <b-row>
                      <b-col>
                        <b-form-group label="Organization" label-for="organizationId">
                          <FormulateInput
                            id="organizationId"
                            name="organizationId"
                            type="select"
                            input-class="form-control"
                            validation="required"
                            placeholder="Choose organization"
                            validation-name="Organization"
                            title="asdasd"
                            :disabled="isUpdating"
                            :options="
                              organizations.map((d) => ({
                                value: d.id,
                                label: d.name,
                              }))
                            "
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <b-form-group label="Set as default" label-for="isDefault">
                        <div
                          class="
                            custom-control
                            custom-switch
                            custom-switch-text
                            custom-control-inline
                            custom-switch-color
                          "
                        >
                          <div class="custom-switch-inner">
                            <input
                              type="checkbox"
                              class="custom-control-input bg-success"
                              :id="'customSwitch-11'"
                              v-model="addUserOrganizationFormValues.isDefault"
                            />
                            <label
                              class="custom-control-label custom-control-label-big"
                              :for="'customSwitch-11'"
                            ></label>
                          </div>
                        </div>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="text-center">
                      <b-col>
                        <b-button
                          type="submit"
                          variant="primary"
                          data-cy="submit-button"
                          class="mt-2 mb-2"
                          @click="addUserOrganization"
                          >Add user to organization</b-button
                        >
                      </b-col>
                    </b-row>
                  </FormulateForm>
      </b-modal>
  </b-container>
</template>

<script>
import { core } from "../../config/pluginInit";
import gql from "graphql-tag";
import { getAccountSync } from "../../Utils/account";

const GET_USER = gql`
  query getUser($id: uuid!) {
    users_by_pk(id: $id) {
      id
      first_name
      last_name
      email
      organization_id
      avatar_url
      avatar_color
      organizations {
        id
        default
        organization {
          name
        }
      }
    }
  }
`;
const UPDATE_USER = gql`
  mutation updateUser(
    $id: uuid!
    $firstName: String
    $lastName: String
    $email: String!
    $avatarUrl: String,
    $avatarColor: String
  ) {
    update_users_by_pk(
      pk_columns: { id: $id }
      _set: {
        first_name: $firstName
        last_name: $lastName
        email: $email
        avatar_url: $avatarUrl
        avatar_color: $avatarColor
      }
    ) {
      id
      first_name
      last_name
      email
      organization_id
      avatar_url
      avatar_color
    }
  }
`;
const LIST_ORGANIZATIONS_WHERE_ADMIN = gql`
  query listOrganizations($adminId: uuid!) {
      organizations(
        where: {
          admin_id: {
            _eq: $adminId
          }
        }
      ) {
        id
        name
      }
  }
`;
const DELETE_USER_ORGANIZATION = gql`
  mutation deleteUserOrganization($id: uuid!) {
    delete_user_organization_by_pk(id: $id){
      id
    }
  }
`;
const ADD_USER_ORGANIZATION = gql`
  mutation addUserOrganization(
    $userId: uuid!,
    $organizationId: uuid!,
    $default: Boolean!,
  ){
    insert_user_organization_one(
      object: {
        user_id: $userId,
        organization_id: $organizationId,
        default: $default
      }
    ){
      id
      user_id
      organization_id
      default
    }
  }
`;

export default {
  name: "UsersEdit",
  data() {
    return {
      formValues: {
        firstName: "",
        lastName: "",
        email: "",
        avatarUrl: "",
        avatarColor: "",
      },
      organizations: [],
      colors: [
        {label: "None", value: null },
        {label: "Red", value: "#FFC0C0" },
        {label: "Green", value: "#C0DCC0" },
        {label: "Blue", value: "#C0C0FF" },
        {label: "Yellow", value: "#FFFFC0" },
        {label: "Orange", value: "#FFD8B1" },
        {label: "Purple", value: "#D8BFD8" },
        {label: "Cyan", value: "#C0FFFF" },
        {label: "Magenta", value: "#FFC0FF" },
        {label: "Lime", value: "#C0FFC0" },
        {label: "Pink", value: "#FFD1DC" },
        {label: "Teal", value: "#C0E4E4" },
        {label: "Lavender", value: "#E6E6FA"},
        {label: "Brown", value: "#DECAB1" },
        {label: "Beige", value: "#F5F5DC" },
        {label: "Olive", value: "#D8E4BC" },
        {label: "Maroon", value: "#E0B0FF" }
      ],
      userOrganizationsFields: [
        { key: "organization", label: "Organization", sortable: false },
        { key: "action", label: "Actions", sortable: false }
      ],
      toAddModalOpened: false,
      addUserOrganizationFormValues: {
        userId: "",
        organizationId: "",
        isDefault: false,
      },
      toDeleteUserOrganization: null,
    };
  },
  apollo: {
    user() {
      return {
        query: GET_USER,
        variables: {
          id: this.$route.params.id
        },
        update: data => {
          this.formValues.firstName = data.users_by_pk.first_name;
          this.formValues.lastName = data.users_by_pk.last_name;
          this.formValues.email = data.users_by_pk.email;
          this.formValues.avatarUrl = data.users_by_pk.avatar_url;
          this.formValues.avatarColor = data.users_by_pk.avatar_color;
          return data.users_by_pk;
        }
      };
    },
    organizations(){
      return {
        query: LIST_ORGANIZATIONS_WHERE_ADMIN,
        variables: {
          adminId: getAccountSync().userId,
        }
      }
    }
  },
  methods: {
    async submitHandler() {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_USER,
          variables: {
            id: this.$route.params.id,
            firstName: this.formValues.firstName,
            lastName: this.formValues.lastName,
            email: this.formValues.email,
            avatarUrl: this.formValues.avatarUrl ?? undefined,
            avatarColor: this.formValues.avatarColor ?? undefined,
          }
        });
        this.$toast.success(`User updated`);
      } catch (error) {
        this.$toast.error(`Failed to update user: ${error.message}`);
      }
    },
    async deleteItem(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_USER_ORGANIZATION,
          variables: {
            id
          }
        });
        this.$toast.success(`User in organization deleted`);
        this.toDeleteUserOrganization = null;
        this.$apollo.queries.user.refetch();
      } catch (error) {
        this.$toast.error(`Failed to delete user from organization: ${error.message}`);
      }
    },
    async addUserOrganization(){
      try {
        await this.$apollo.mutate({
          mutation: ADD_USER_ORGANIZATION,
          variables: {
            userId: this.$route.params.id,
            organizationId: this.addUserOrganizationFormValues.organizationId,
            default: this.addUserOrganizationFormValues.isDefault
          }
        });
        this.$toast.success(`User added to organization.`);
        this.addUserOrganizationFormValues = {
          userId: "",
          organizationId: "",
          isDefault: false,
        };
        this.$apollo.queries.user.refetch();
      } catch (error) {
        this.$toast.error(`Failed to add user to organization: ${error.message}`);
      }
      this.toAddModalOpened = false;
    }
  },
  computed: {
    userOrganizations(){
      return this.user?.organizations.map(o => ({
        id: o.id,
        organization: o.organization.name,
        default: o.default
      }))
    }
  },
  mounted() {
    core.index();
  }
};
</script>
